// App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CssBaseline, Box, ThemeProvider, createTheme } from "@mui/material";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import Sidebar from "./components/Sidebar";
import { Navigate } from "react-router-dom";
import { private_routes } from "./routes/routes";
import { SnackbarProvider } from "notistack";
import { AppProvider, useAppContext } from "./contexts/AppContext";

const App: React.FC = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#2A4365",
      },
      secondary: {
        main: "#dc004e",
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <SnackbarProvider>
          <AuthProvider>
            <CssBaseline />
            <Router>
              <Content />
            </Router>
          </AuthProvider>
        </SnackbarProvider>
      </AppProvider>
    </ThemeProvider>
  );
};

const Content: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { isCollapsed, toggleCollapse } = useAppContext();

  return (
    <Box
      sx={
        isAuthenticated
          ? {
              display: "flex",
            }
          : {
              height: "100%",
              width: "100%",
            }
      }
    >
      {isAuthenticated && <Sidebar />}
      <Box
        sx={{
          flex: 1,
          height: "100%",
          ...(isAuthenticated
            ? isCollapsed
              ? {
                  width: "calc(100vw - 70px)",
                }
              : { width: "calc(100vw - 270px)" }
            : {}),
        }}
      >
        <Routes>
          <Route path="/login" element={<PublicRoute element={<Login />} />} />
          {private_routes.map((route) => (
            <Route
              path={route.path}
              element={<PrivateRoute element={<route.component />} />}
            />
          ))}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default App;
